import type { LinkProps, NSLink } from './Link.types';

export { default } from './Link';
export type { LinkProps, NSLink };
